const EstrellaDoradaIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2799 7.41271L16.3973 7.68353L16.6912 7.71153L23.4109 8.35176L23.4112 8.35179C24.4505 8.45018 24.8724 9.74471 24.0877 10.4376L24.0877 10.4376L19.0282 14.9056L18.807 15.101L18.8712 15.3891L20.3388 21.9773L20.3388 21.9773C20.5663 22.9982 19.465 23.7985 18.5635 23.2664L18.3093 23.697L18.5635 23.2664L12.7512 19.836L12.497 19.686L12.2429 19.8361L6.43065 23.2678C6.43063 23.2678 6.43061 23.2678 6.43059 23.2678C5.52906 23.7999 4.42782 22.9995 4.65531 21.9787L4.65532 21.9786L6.12297 15.3905L6.18715 15.1024L5.9659 14.907L0.906452 10.4389L0.906414 10.4389C0.121985 9.74632 0.543302 8.45161 1.58427 8.35315L1.58462 8.35312L8.30297 7.71289L8.59682 7.68488L8.71426 7.41406L11.4 1.22065L11.4154 1.18516C11.8485 0.260375 13.1832 0.271752 13.5942 1.21929C13.5942 1.2193 13.5942 1.2193 13.5942 1.21931L16.2799 7.41271Z"
        fill="#DBC500"
        stroke="#594200"
      />
    </svg>
  );
};

export default EstrellaDoradaIcon;
